module.exports = __webpack_public_path__ + "static/media/acessar-url-mobile.d56e556f.jpg";